import { MutationTree } from "vuex";
import { BrandingState, BRANDING_STORAGE_KEY } from "./interfaces";
import { SET_BRANDING } from "./constants";

const mutations: MutationTree<BrandingState> = {
  [SET_BRANDING](state, payload: Partial<BrandingState>) {
    state.slug = payload.slug || "";
    state.title = payload.title || "";
    state.logo_uri = payload.logo_uri || "";
    state.favicon_uri = payload.favicon_uri || "";
    state.primary_color = payload.primary_color || "";
    state.loaded = true;
    try {
      localStorage.setItem(
        BRANDING_STORAGE_KEY,
        JSON.stringify({
          slug: state.slug,
          title: state.title,
          logo_uri: state.logo_uri,
          favicon_uri: state.favicon_uri,
          primary_color: state.primary_color
        })
      );
    } catch {
      // ignore storage failures
    }
  }
};

export default mutations;
